import { BaseApi } from '@/main/baseApi';
import { PRReturnPolozky } from '@/modules/sklad/PRReturn/polozky';

import { DependentTableNames, PRReturnAttachmentFiles, MODULE_API, NAME } from './constants';

export const prReturnTiskUrl = '/Reports/Reports/GetPrReturnReport';
export const partPurCreditMemoUrl = '/Servis/Reports/GetPostedPartsPurchaseCreditMemoReport';

class PRReturnProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PRReturnPolozky.name:
				return `/${this.area}/${PRReturnPolozky.name}/Schema`;
			case PRReturnAttachmentFiles:
				return `/${this.area}/${NAME}/${PRReturnAttachmentFiles}Schema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PRReturnPolozky.name:
				return `/${this.area}/${PRReturnPolozky.name}/PRReturnPolozkyRows`;
			case PRReturnAttachmentFiles:
				return `/${this.area}/${NAME}/${PRReturnAttachmentFiles}Rows`;
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	saveDocument(fileList: any, PrPartReturnId: null | number) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${MODULE_API}/${NAME}/SaveDocument?PR_PART_RETURN_ID=${PrPartReturnId}`, file);
	}

	getDocuments(fileId: number) {
		return this.fetch(`/${MODULE_API}/${NAME}/GettachamentFilestDocument?fileId=${fileId}`);
	}

	savePRReturnParts(dto: any) {
		return this.post(`/${MODULE_API}/PRReturnPolozky/SavePRReturnParts`, dto);
	}

	savePRReturn(dto: any) {
		return this.post(`/${MODULE_API}/${NAME}/SavePRReturn`, dto);
	}

	deleteAttachamentDocuments(fileId: number) {
		return this.post(`/${MODULE_API}/${NAME}/deleteAttachamentDocuments?fileId=${fileId}`);
	}

	async raisePrReturn(filter: any) {
		return this.post(`/${MODULE_API}/${NAME}/PrReturnRaiseApproval`, filter);
	}

	async approvePrReturn(filter: any) {
		return this.post(`/${MODULE_API}/${NAME}/ApprovePrReturn`, filter);
	}

	async rejectPrReturn(filter: any) {
		return this.post(`/${MODULE_API}/${NAME}/RejectPrReturn`, filter);
	}

	async generateInvoice(dto: any) {
		return this.post(`/${MODULE_API}/${NAME}/GenerateInvoice`, dto);
	}
	async IsDuplicatePRRequestExists(dto: any) {
	return this.post(`/${MODULE_API}/${NAME}/IsDuplicatePRRequestExists`, dto);
}

}

export const apiProvider = new PRReturnProvider(MODULE_API, NAME);
